<div class="title-container">
  <h3 class="title">
    {{ 'Reports.PortfolioReport.SuccessRateVsAgeClaim' | translate }}
  </h3>
  <hr class="separation-line" />
</div>

<div class="canvas">
  <canvas [id]="canvasId"></canvas>
</div>
